import { useLocalObservable } from 'mobx-react-lite';

export const useJobDotIsState = () => {
  const state = useLocalObservable(() => ({
    startDate: new Date(),
    slogan: '',
    twitter: '',
    facebook: '',
    linkedin: '',
    location: '',
    contactEmail: '',
    companyEmail: '',
    setTextField(field, value) {
      state[field] = value;
    },
    get form() {
      return {
        email: state.contactEmail,
        company_location: state.location,
        company_foundation: state.slogan,
        company_email: state.companyEmail,
        company_facebook: state.facebook,
        company_twitter: state.facebook,
        company_linkedin: state.facebook,
        job_startdate: state.startDate ? state.startDate.toISOString() : '',
      };
    },
  }));

  return state;
};
